import { useDimensions } from '@tecsinapse/cortex-react'
import { useState } from 'react'
import { download } from '../utils/biblioteca-actions'
import { useSearchBiblioteca } from './use-search-biblioteca'
import { useGenerateDownloadLink } from './use-generate-download-link'
import { MODE_OPTIONS } from '../utils/view-options'
import { useBibliotecaFolderActions } from './use-biblioteca-folder-actions'
import { CONST_ROOT_FOLDER } from '../utils/constants'
import { ItemBiblioteca } from '@/core/types/graphql'
import { SelectedItemBiblioteca } from '@/modules/biblioteca-virtual/types/types'

export const useBibliotecaVirtual = () => {
  const [newFolderOpen, setNewFolderOpen] = useState(false)
  const [isFolder, setIsFolder] = useState<boolean>(false)
  const [mode, setMode] = useState(MODE_OPTIONS[0].value)

  const { generateDownloadLink } = useGenerateDownloadLink()

  const { width } = useDimensions()
  const isMobile = width <= 768

  const { searchText, setSearchText, searchDebounce, isSearching } =
    useSearchBiblioteca()

  const {
    itemsPorPasta,
    loadingItemsPorPasta,
    pasta,
    loadingPasta,
    pastasOptions,
    hasItems
  } = useBibliotecaFolderActions()

  const isRoot = pasta?.id === CONST_ROOT_FOLDER

  const hasWritePermission = pasta?.permissoesAcessoUsuarioLogado.some(
    permissao => permissao?.id === 'LEITURA_ESCRITA'
  )

  const pastas = itemsPorPasta?.filter(item => item?.isPasta)
  const arquivos = itemsPorPasta?.filter(item => !item?.isPasta)
  const images = itemsPorPasta?.filter(item => item?.arquivoImagem)

  const showItensList = mode.type === 'list'
  const showItensModule = mode.type === 'grid'
  const dontShowUploadUI = hasItems || isRoot || isSearching

  const isItemSelected = (rows: SelectedItemBiblioteca[], itemId: string) =>
    rows.some(row => row.data.id === itemId && row.selected)

  const onClickDownloadItem = (item: ItemBiblioteca) => {
    if (!item.isPasta) {
      download(generateDownloadLink, item)
    }
  }

  return {
    searchText,
    setSearchText,
    pasta,
    loadingPasta,
    isSearching,
    searchDebounce,
    pastas,
    isRoot,
    loadingPastas: loadingItemsPorPasta,
    hasWritePermission,
    isItemSelected,
    onClickDownloadItem,
    itemsPorPasta,
    pastasOptions,
    generateDownloadLink,
    mode,
    setMode,
    isFolder,
    setIsFolder,
    newFolderOpen,
    setNewFolderOpen,
    showItensList,
    showItensModule,
    dontShowUploadUI,
    arquivos,
    isMobile,
    images
  }
}
